import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { factoryService, getJsonRequest, putJsonRequest } from '@chilecompra/react-kit/requests'

/**
 * Save Quote's and gets number, name and details from service
 */
export const saveQuoteStepOne = factoryService(
  ({
    address,
    amount,
    closingDate,
    code,
    contactPhone,
    contactName,
    contactEmail,
    detail,
    districtCode,
    deliveryTime,
    exchangeRate,
    regionCode,
    name,
    secondCallAutomatic,
    budgetType
  }) => {
    const body = {
      codigoComuna: districtCode,
      codigoRegion: regionCode,
      descripcion: detail,
      direccion: address,
      email: contactEmail,
      fechaCierre: closingDate,
      moneda: exchangeRate,
      monto: amount,
      nombre: name,
      nombreContacto: contactName,
      plazoEntrega: deliveryTime,
      telefono: contactPhone,
      activaSegundaConvocatoria: secondCallAutomatic,
      tipoPresupuesto: budgetType
    }

    if (code !== undefined) body.codigoSolicitud = code

    return putJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/borrador/paso1`, { body })
  }
)

/**
 * Save products and change the quote status
 */
export const publishQuoteRequest = factoryService(
  ({
    code,
    companySizeFilter,
    finesPenalties,
    filterRegionCode,
    filterRegionNotification,
    sellersAddedDni,
    products,
    isEnvironmental,
    isSocialEconomic
  }) => {
    const body = {
      codigoRegionFiltro: filterRegionCode,
      codigoSolicitud: code,
      esMultaSancion: finesPenalties ? 1 : 0,
      filtroRegionNotificacion: filterRegionNotification,
      filtroTamanoEmpresa: companySizeFilter ? 1 : 0,
      proveedores: sellersAddedDni,
      productos: products.map(product => ({
        codigoProducto: product.productId,
        idCategoria: product.categoryId,
        cantidad: product.quantity,
        descripcion: product.detail,
        unidad: {
          id: product.unit
        }
      })),
      consideraRequisitosMedioambientales: isEnvironmental,
      consideraRequisitosImpactoSocialEconomico: isSocialEconomic
    }

    return putJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/publicar`, { body })
  }
)

/**
 * Extends the quote closing date.
 */
export const extendQuoteClosingDate = factoryService(({ closingDate, code }) => {
  const body = { codigoCotizacion: code, fechaCierre: closingDate }

  return putJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/cierre/extender`, { body })
})

/**
 * Make second call quote.
 */
export const makeSecondCallQuote = factoryService(({ id }) => {
  return putJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/activarSegundaConvocatoria/${id}`)
})

/**
 * To cancel a quote.
 */
export const cancelQuote = factoryService(({ quoteID, justification }) => {
  const body = { detalle: justification }

  return putJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/cotizacion/${quoteID}/cancelar`, {
    body
  })
})

export const saveRoughCopy = factoryService(
  ({
    code,
    companySizeFilter,
    filterRegionCode,
    filterRegionNotification,
    finesPenalties,
    sellersAddedDni,
    products,
    isEnvironmental,
    isSocialEconomic
  }) => {
    const body = {
      codigoRegionFiltro: filterRegionCode,
      codigoSolicitud: code,
      esMultaSancion: finesPenalties ? 1 : 0,
      filtroTamanoEmpresa: companySizeFilter ? 1 : 0,
      filtroRegionNotificacion: filterRegionNotification,
      proveedores: sellersAddedDni,
      productos: products.map(product => ({
        codigoProducto: product.productId,
        idCategoria: product.categoryId,
        cantidad: product.quantity,
        descripcion: product.detail,
        unidad: {
          id: product.unit
        }
      })),
      consideraRequisitosMedioambientales: isEnvironmental,
      consideraRequisitosImpactoSocialEconomico: isSocialEconomic
    }
    return putJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/borrador/paso2`, { body })
  }
)

/**
 * Gets the quote step one information
 */
export const getQuoteStepOne = factoryService(({ code }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/cotizacion/${code}`)
)
